export const statusSummaryCellRenderer = function(params) {
  var status = params.value.toLowerCase()
  return `<span class="ag-group-value flight-status ${status}">${params.value}</span>`
}
